import {
  Business,
  FolderOpenOutlined,
  People,
  Settings,
  LocalOffer as LocalOfferIcon,
  Hub as HubIcon,
  ConnectWithoutContact as ConnectWithoutContactIcon,
  BusinessCenter as BusinessCenterIcon,
  Call as CallIcon,
  PictureAsPdf as PictureAsPdfIcon,
  Feed as FeedIcon,
  ImageOutlined as ImageOutlinedIcon,
  OndemandVideoOutlined as OndemandVideoOutlinedIcon,
  AudioFileOutlined as AudioFileOutlinedIcon,
  HtmlOutlined as HtmlOutlinedIcon,
  InsertLinkOutlined as InsertLinkOutlinedIcon,
  WhatsApp as WhatsAppIcon,
  BlurCircular as BlurCircularIcon,
  Dashboard as DashboardIcon,
  Security as SecurityIcon
} from '@mui/icons-material';
import { FormResultsStatuses, PredefinedSection, LeadStatus } from '@sm-dashboard/reshet-types';
import React from 'react';
import { ChipProps } from '@mui/material';

//auth Urls
export const loginUrl = `pvt/auth/login`;
export const loginMfaUrl = `pvt/auth/login-mfa`;
export const resendMfa = `pvt/auth/re-send-mfa`;
export const verifyPhoneUrl = `pvt/auth/verify-phone`;
export const registerMfaUrl = `pvt/auth/register-mfa`;
export const reshetGoogleAuthUrl = 'pvt/auth/google-auth-url';

//report Urls
export const reportUrl = `pub/report`;

//count Urls
export const staffMembersCountUrl = `pvt/staff-members/count`;
export const institutionsCountUrl = `pvt/institutions/count`;
export const institutionsByStaffMembersCountUrl = `pvt/institutions/institutions-by-staffMembers-count`;

//map
export const layersUrl = 'pvt/layers';
export const institutionDetailsUrl = 'pvt/institutions/institutions-with-staffMembers-details';
export const institutionLatlngUrl = 'pvt/institutions/institution-latlng';

//all
export const staffMembersAllUrl = `pvt/staff-members/all`;
export const institutionsAllPubUrl = `pub/institutions/all`;

export const institutionsAllUrl = `pvt/institutions/all`;

export const editGeomUrl = 'pvt/institutions/edit-geom-request';
export const institutionsPolygonAndCenterUrl = `pvt/institutions/institutions-polygon-center-lat-lng`;

//institutions
export const institutionsGroupForFiltersUrl = 'pvt/institutions/group-for-filters';
export const updateInstitutionUrl = 'pvt/institutions/update-institution-details';
export const getInstitutionByIdUrl = 'pvt/institutions/:id';
export const createInstitutionUrl = 'pvt/institutions/create-new-institution';
export const deleteInstitutionUrl = 'pvt/institutions/delete-institution';
export const canManageInstitutionUrl = 'pvt/institutions/:institutionId/can-manage';

//staff-members
export const staffMembersGroupForFiltersUrl = 'pvt/staff-members/group-for-filters';
export const staffMembersAllWithDetailsUrl = `pvt/staff-members/all-staffMembers-with-details`;
export const updateStaffMemberUrl = 'pvt/staff-members/update-staffMember-details';
export const addStaffMemberUrl = 'pvt/staff-members/add-staffMember';
export const getStaffMemberByIdUrl = 'pvt/staff-members/staffMember-by-id';
export const deleteStaffMemberUrl = 'pvt/staff-members/:id';

//staff institution roles
export const getStaffMemberInstitutionRolesUrl = 'pvt/staff-members/institution-roles';
export const updateStaffMemberInstitutionRolesUrl = 'pvt/staff-members/institution-roles';
export const updateConnectionRolesUrl = 'pvt/staff-members/institution-roles/:connectionId';
export const removeConnectionRolesUrl = 'pvt/staff-members/institution-roles/:connectionId';

// Grant fund (קרן חינוך)
export const grantFundRequestsUrl = 'pvt/grant-fund/requests';
export const grantFundSubmissionsUrl = 'pvt/grant-fund/submissions';
export const grantFundDashboardUrl = 'pvt/grant-fund/dashboard';

// Loans (הלוואות)
export const loansRequestsUrl = 'pvt/loans/requests';
export const loansSubmissionsUrl = 'pvt/loans/submissions';

// Supports (תמיכות)
export const supportsRequestsUrl = 'pvt/supports/requests';
export const supportsSubmissionsUrl = 'pvt/supports/submissions';

// Institution staff roles endpoints
export const getInstitutionStaffRolesUrl = 'pvt/institutions/staff-roles/:institutionId';
export const addStaffRoleToInstitutionUrl = 'pvt/institutions/staff-roles/:institutionId/add';
export const updateInstitutionStaffRoleUrl = 'pvt/institutions/staff-roles/:institutionId/:connectionId';
export const removeStaffFromInstitutionUrl = 'pvt/institutions/staff-roles/:institutionId/:connectionId';

//leads
export const leadsUrl = 'pvt/leads/leads-by-id';
export const createLeadUrl = 'pvt/leads/add-lead';
export const leadsGroupForFiltersUrl = 'pvt/leads/group-for-filters';
export const updateLeadsByIdUrl = 'pvt/leads/update-by-id';
export const deleteLeadsByIdUrl = 'pvt/leads/delete-by-id';
export const bulkDeleteLeadsUrl = 'pvt/leads/bulk-delete';
export const bulkMoveLeadsUrl = 'pvt/leads/bulk-move';
export const isNewLeadsCountUrl = 'pvt/leads/is-new-leads-count';
export const shalhavotDashboardUrl = 'pvt/leads/shalhavot-dashboard';
export const getShalhavotTargetUrl = 'pvt/leads/target/shalhavot';
export const kindergartenDashboardUrl = 'pvt/leads/kindergarten-dashboard';
export const getKindergartenTargetUrl = 'pvt/leads/target/kindergarten';
export const daycareCentersDashboardUrl = 'pvt/leads/daycare-centers-dashboard';
export const getDaycareCentersTargetUrl = 'pvt/leads/target/daycare-centers';

//Donations
export const donationsUrl = 'pvt/donations/donations-by-id';
export const donationsGroupForFiltersUrl = 'pvt/donations/group-for-filters';
export const updateDonationsByIdUrl = 'pvt/donations/update-by-id';
export const deleteDonationsByIdUrl = 'pvt/donations/delete-by-id';

//orders
export const ordersUrl = 'pvt/orders/orders-by-id';
export const ordersGroupForFiltersUrl = 'pvt/orders/group-for-filters';
export const updateOrdersByIdUrl = 'pvt/orders/update-by-id';
export const addOrdersByIdUrl = 'pvt/orders/add-order';
export const deleteOrdersByIdUrl = 'pvt/orders/delete-by-id';

//Operations to
export const forwardOperationToStaffMemberUrl = 'pvt/staff-members/forward-operations-to-staffMember';
export const deleteOperationToStaffMemberUrl = 'pvt/staff-members/delete-operations-to-staffMember';
export const allOperationsToStaffMemberUrl = 'pvt/staff-members/all-operations-to-staffMember';
export const allLadsOperationsUrl = 'pvt/staff-members/all-leads-operations';
export const getAllOperationsUrl = 'pvt/staff-members/all-leads-operations';
export const getAllInstitutionsUrl = 'pvt/institutions/all';

//Stam
export const stamOrdersByIdUrl = 'pvt/stam/orders-by-id';
export const stamUpdateCheckUrl = 'pvt/stam/update-check';
export const stamCreateOrderUrl = 'pvt/stam/create-order';
export const stamDeleteCheckUrl = 'pvt/stam/delete-check';
export const stamDeleteOrderUrl = 'pvt/stam/delete-order';
export const stamGroupForFiltersUrl = 'pvt/stam/group-for-filters';

//Feed
export const addPostUrl = 'pvt/feed/add-post';
export const deletePostUrl = 'pvt/feed';
export const updatePostUrl = 'pvt/feed';
export const getPostsUrl = 'pvt/feed';
export const likeOrLikePostUrl = 'pvt/feed/like';
export const addCommentUrl = 'pvt/feed/add-comment';
export const getCommentsUrl = 'pvt/feed/get-comments';
export const updateCommentUrl = 'pvt/feed/update-comment';
export const deleteCommentUrl = 'pvt/feed/delete-comment';

//Archive
export const archiveUrl = 'pvt/archive';
export const archiveAllUrl = 'pvt/archive/all';
export const archiveAddUrl = 'pvt/archive/add-archive-meta';
export const archiveDeleteUrl = 'pvt/archive';
export const archiveUpdateUrl = 'pvt/archive/update-archive-meta';
export const resortingUpdateUrl = 'pvt/archive/resorting-archive-meta';
export const archiveSortingUpdateUrl = 'pvt/archive/sorting';

export const archiveDataUrl = 'pvt/archive/data';
export const getArchiveMetaBreadcrumbsUrl = 'pvt/archive/breadcrumbs';
export const archiveDataUploadUrl = 'pvt/archive/add-data-file';
export const archiveDataAddUrl = 'pvt/archive/data/add-archive-data';
export const archiveDataUpdateUrl = 'pvt/archive/data/update-archive-data';
export const archiveDataSendWaUrl = 'pvt/archive/data/send-wa';
export const archiveDataSortingUpdateUrl = 'pvt/archive/data/sorting';
export const archiveDataPermissionsUrl = 'pvt/archive/data/update-tags-allow';
export const archiveDataAllUrl = 'pvt/archive/data/all-data';
export const kedmaGroupForFiltersUrl = 'pvt/archive/data/group-for-filters';
export const archiveDownloadImageUrl = 'pvt/archive/data/download-image';

//Archive Favorites
export const addArchiveFavoriteUrl = 'pvt/archive/favorites';
export const removeArchiveFavoriteUrl = 'pvt/archive/favorites';
export const getUserArchiveFavoritesUrl = 'pvt/archive/favorites/user';

//Assets
export const assetsUrl = 'pvt/assets';
export const assetsAddUrl = 'pvt/assets/add-asset';
export const assetsDeleteUrl = 'pvt/assets';
export const assetsUpdateUrl = 'pvt/assets/update-asset';

//Campaigns
export const campaignsUrl = 'pvt/campaigns';
export const getPersonalCampaignsUrl = 'pvt/campaigns/get-personal-pages';
export const postPersonalCampaignsUrl = 'pvt/campaigns/post-personal-page';
export const deletePersonalCampaignUrl = 'pvt/campaigns/del-personal-page';
export const updatePersonalCampaignUrl = 'pvt/campaigns/update-personal-page';
export const basePublicWebsiteUrl = 'https://chabadisrael.co.il';

//Tags
export const addTagUrl = 'pvt/tags/addtag';
export const updateTagUrl = 'pvt/tags/:tagName';
export const deleteTagUrl = 'pvt/tags/:tagName';
export const getTagsUrl = 'pvt/tags/distinct';

//FormsCreation
export const formsUrl = 'pvt/forms';
export const submitFormUrl = 'pvt/forms/submit-form';
export const updateFormUrl = 'pvt/forms/update-form';
export const deleteFormUrl = 'pvt/forms/delete-form';
export const publicFormsUrl = 'pub/forms';
export const publicFormsResultsUrl = 'pub/forms-results';
export const publicVerifyFormPaymentUrl = 'pub/forms-results/verify-payment';

export const formsGroupForFiltersUrl = 'pvt/forms/group-for-filters';

//FormResults
export const submitFormResultUrl = 'pvt/form-results/submit-form-result';
export const getFormResultsUrl = 'pvt/form-results';
export const updateFormResultUrl = 'pvt/form-results/update-form-result';
export const deleteFormResultUrl = 'pvt/form-results/delete-form-result';
export const updateManyFormResultsUrl = 'pvt/form-results/update-form-results';
export const deleteManyFormResultsUrl = 'pvt/form-results/delete-form-results';
export const formResultsGroupForFiltersUrl = 'pvt/form-results/group-for-filters';

//Departments
export const departmentsUrl = 'pvt/departments';
export const addDepartmentUrl = 'pvt/departments/add-department';
export const updateDepartmentUrl = 'pvt/departments/update-department';
export const deleteDepartmentUrl = 'pvt/departments/delete-department';

//PredefinedSections
export const predefinedSectionsUrl = 'pvt/predefined-sections';

//Shluchim
export const getAllShluchimUrl = 'pvt/shluchim';
export const getStaffForManagerUrl = 'pvt/staff-members/for-manager';
export const getStaffForRegistrationManagerUrl = 'pvt/staff-members/for-registration-manager';

//
export const homeStaffMemberDashboardUrl = 'pvt/home';

//Bucket
export const uploadFileUrl = 'pvt/bucket/upload-file-to-cloud-storage';

export const canvaColor = '#00C4CC';

type MobilePage = {
  primary: string;
  link: string;
  icon: JSX.Element;
};

export const mobilePagesList: MobilePage[] = [
  {
    primary: 'רישום גנים',
    link: '/kindergarten-leads',
    icon: <CallIcon />
  },
  {
    primary: 'רישום שלהבות',
    link: '/shalhavot-leads',
    icon: <CallIcon />
  },
  {
    primary: 'רישום מעונות',
    link: '/daycare-centers-leads',
    icon: <CallIcon />
  },
  {
    primary: 'פיד',
    link: '/feed',
    icon: <FeedIcon />
  },
  {
    primary: 'פרטים אישיים',
    link: '/details',
    icon: <People />
  }
];

type Page = {
  primary: string;
  icon?: JSX.Element;
  link?: string;
  children?: Page[];
};

export const pagesList: Page[] = [
  {
    primary: 'לידים',
    icon: <ConnectWithoutContactIcon color="inherit" />,
    children: [
      {
        primary: 'רישום גנים',
        link: '/kindergarten-leads',
        icon: <CallIcon color="inherit" />
      },
      {
        primary: 'רישום שלהבות',
        link: '/shalhavot-leads',
        icon: <CallIcon color="inherit" />
      },
      {
        primary: 'רישום מעונות',
        link: '/daycare-centers-leads',
        icon: <CallIcon color="inherit" />
      }
    ]
  },
  {
    primary: 'רשת',
    icon: <HubIcon color="inherit" />,
    children: [
      {
        primary: 'פיד',
        link: '/feed'
      },
      {
        primary: 'טפסים ושאלונים',
        link: '/forms'
      },
      {
        primary: 'ספר שלוחי חינוך',
        link: '/staff-members-book'
      },
      {
        primary: 'ספר המוסדות',
        link: '/institutions-list'
      },
      {
        primary: 'קישורים',
        link: '/links'
      }
    ]
  },
  {
    primary: 'שופרא',
    icon: <BusinessCenterIcon color="inherit" />,
    children: [
      {
        primary: 'שופרא - שלהבות',
        link: '/shufra/shalhavot'
      },
      {
        primary: 'שופרא - גנים',
        link: '/shufra/kindergartens'
      },
      {
        primary: 'שופרא - בתי ספר',
        link: '/shufra/schools'
      }
    ]
  },
  {
    primary: 'קרן חינוך',
    icon: <SecurityIcon color="inherit" />,
    children: [
      {
        primary: 'בקשות במעגל השנה',
        link: '/grant-fund',
        icon: <SecurityIcon color="inherit" />
      },
      {
        primary: 'הלוואות',
        link: '/loans',
        icon: <SecurityIcon color="inherit" />
      },
      {
        primary: 'תמיכות',
        link: '/supports',
        icon: <SecurityIcon color="inherit" />
      }
    ]
  },
  {
    primary: 'ניהול מערכת',
    icon: <Settings />,
    children: [
      { primary: 'משתמשים', icon: <People />, link: '/users' },
      { primary: 'מוסדות', icon: <Business />, link: '/institutions' },
      { primary: 'תגיות', icon: <LocalOfferIcon />, link: '/tags' },
      {
        primary: 'בקשות במעגל השנה - מערכת מנהלים',
        icon: <SecurityIcon color="inherit" />,
        link: '/grant-fund/system'
      },
      {
        primary: 'הלוואות',
        icon: <SecurityIcon color="inherit" />,
        link: '/loans/system'
      },
      {
        primary: 'תמיכות',
        icon: <SecurityIcon color="inherit" />,
        link: '/supports/system'
      }
    ]
  }
];

//List of all pages with primary and link for permission tags
export const flattenPagesList = pagesList.reduce(
  (acc: { primary: string; link: string; icon: JSX.Element }[], curr) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    acc.push({ primary: curr.primary, link: curr.link || '', icon: curr.icon! });
    if (curr.children) {
      curr.children.forEach(child => {
        acc.push({
          primary: child.primary,
          link: child.link || '',
          // eslint-disable-next-line react/jsx-no-useless-fragment
          icon: 'icon' in child && React.isValidElement(child.icon) ? child.icon : <></>
        });
      });
    }
    return acc;
  },
  []
);

export enum FileType {
  'folder' = 'folder',
  'pdf' = 'pdf',
  'image' = 'image',
  'video' = 'video',
  'audio' = 'audio',
  'html' = 'html',
  'wa' = 'wa',
  'link' = 'link',
  'doc' = 'doc',
  'kedma' = 'kedma',
  'images' = 'images'
}

export const speedDialActions = [
  {
    icon: <FolderOpenOutlined color="secondary" />,
    tooltipTitle: 'הוסף תיקייה',
    dialogType: FileType?.folder
  },
  {
    icon: <PictureAsPdfIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ PDF',
    dialogType: FileType?.pdf
  },
  {
    icon: <ImageOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ תמונה',
    dialogType: FileType?.image
  },
  {
    icon: <OndemandVideoOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ וידיאו',
    dialogType: FileType?.video
  },
  {
    icon: <AudioFileOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ שמע',
    dialogType: FileType?.audio
  },
  {
    icon: <HtmlOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קובץ תוכן עשיר',
    dialogType: FileType?.html
  },
  {
    icon: <InsertLinkOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף קישור',
    dialogType: FileType?.link
  },
  {
    icon: <WhatsAppIcon color="secondary" />,
    tooltipTitle: 'הוסף פרסום לאווטסאפ',
    dialogType: FileType?.wa
  },
  {
    icon: <BlurCircularIcon color="secondary" />,
    tooltipTitle: 'הוסף עיצוב קדמה',
    dialogType: FileType?.kedma
  },
  {
    icon: <ImageOutlinedIcon color="secondary" />,
    tooltipTitle: 'הוסף תמונה',
    dialogType: FileType?.images
  }
];

export const phonePrefix = [
  { code: '050' },
  { code: '051' },
  { code: '052' },
  { code: '053' },
  { code: '054' },
  { code: '055' },
  { code: '057' },
  { code: '058' },
  { code: '08' },
  { code: '03' },
  { code: '02' },
  { code: '04' },
  { code: '01' },
  { code: '09' }
];

export enum DepartmentEnum {
  TZACH = 'צעירי אגודת חב״ד',
  EZREI_SHLICHUT = 'המרכז לעזרי שליחות',
  EZREI_SHLUCHOT = 'המרכז לעזרי שלוחות',
  MIVTZA_CHINUCH = 'אגף מבצע חינוך',
  TERROR_VICTIMS = 'אגף נפגעי טרור',
  SECURITY_FORCES = 'אגף כוחות הביטחון',
  SPOKESMAN = 'אגף הדוברות',
  MIVTZA_TORAH = 'אגף מבצע תורה'
}

export const departmentOptions = Object.values(DepartmentEnum).map(department => ({
  value: department,
  label: department
}));

export const formTypeOptions = [
  { value: 'הגשת בקשה', label: 'הגשת בקשה' },
  { value: 'סקר', label: 'סקר' },
  { value: 'שאלון', label: 'שאלון' },
  { value: 'הגשת מסמכים', label: 'הגשת מסמכים' },
  { value: 'הרשמה', label: 'הרשמה' },
  { value: 'מנוי', label: 'מנוי' },
  { value: 'דיווח', label: 'דיווח' },
  { value: 'אחר', label: 'אחר' }
];

export type DetailsSections = 'StaffMemberForm' | 'InstitutionForm' | 'JudikaForm' | 'BetKnesetForm';

// There is a doc in mongoDB with the default fields for the form
export const defaultFormFields: PredefinedSection & { source: string } = {
  value: 'default',
  label: 'פרטים אישיים קבועים',
  source: 'StaffMembers',
  fields: [
    { name: 'name', type: 'string', label: 'שם המשתמש' },
    { name: 'phone', type: 'number', label: 'מספר טלפון' }
  ]
};

export const formResultStatusColor: Record<FormResultsStatuses[number], ChipProps['color']> = {
  חדש: 'default',
  בתהליך: 'warning',
  בטיפול: 'warning',
  מעוכב: 'error',
  נדחה: 'error',
  מבוטל: 'error',
  מאושר: 'success',
  'נדרש דוח': 'warning',
  הסתיים: 'success',
  עדכון: 'info'
};

// Funnel stages mapping for dashboard charts - maps display labels to actual LeadStatus values
export const FUNNEL_STAGES = [
  { label: 'חדש', statuses: [LeadStatus.NEW] },
  { label: 'אין מענה', statuses: [LeadStatus.NO_ANSWER] },
  {
    label: 'בתהליך ראשוני',
    statuses: [LeadStatus.OPEN_INQUIRY, LeadStatus.REQUESTED_CALLBACK, LeadStatus.IN_CONVERSATION_REQUESTED_DETAILS]
  },
  {
    label: 'בתהליך הרשמה',
    statuses: [LeadStatus.INTERESTED_IN_REGISTRATION_IN_PROCESS, LeadStatus.REGISTERED_FOR_EVENT]
  },
  { label: 'נרשמו', statuses: [LeadStatus.REGISTERED_ON_MUNICIPALITY_SITE, LeadStatus.REGISTRATION_COMPLETED] },
  {
    label: 'נסגר ללא רישום',
    statuses: [LeadStatus.NOT_INTERESTED, LeadStatus.ON_HOLD, LeadStatus.CLOSED, LeadStatus.NOT_RELEVANT]
  }
];

// Generic filter params type for chart click navigation
export type FilterParams = {
  field: string;
  values: string[];
};
